const getPageTemplateId = (state, pageId) => {
  const { pages } = state.ws.site.meta;
  const page = pages && pages.find((pageMeta) => pageMeta.id === pageId);
  return page ? page.templateId : null;
};

export default getPageTemplateId;
